// src/pages/FAQPage/FAQPage.tsx
import React from "react";
import { useTranslation } from "react-i18next";
import Nav from "../../components/Nav/Nav";
import HeroSection from "../../components/HeroSection/HeroSection";
import Footer from "../../components/Footer/Footer";
import LibrexBuilding from "../../assets/images/contacthero.webp";
import styles from "./FAQPage.module.css";
import FAQSection from "./FAQSection";

const FAQPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Nav />
      <HeroSection
        title={t("faq_page.title")}
        subtitle={t("faq_page.subtitle")}
        backgroundImage={LibrexBuilding}
      />
      <div className={styles.faqSection}>
        <FAQSection />
      </div>
      <Footer />
    </>
  );
};

export default FAQPage;
